import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'vdr-order-state-label',
  templateUrl: './order-state-label.component.html',
  styleUrls: ['./order-state-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderStateLabelComponent {
  @Input() state: string | boolean;
  @Input() text: string;

  get typeofState() {
    return typeof this.state;
  }

  get chipColorType() {
    switch (this.state) {
      case 'AddingItems':
      case 'ArrangingPayment':
        return '';
      case 'Delivered':
      case true:
        return 'success';
      case 'Cancelled':
      case false:
        return 'error';
      case 'PaymentAuthorized':
      case 'PaymentSettled':
      case 'PartiallyDelivered':
      case 'PartiallyShipped':
      case 'Shipped':
      default:
        return 'warning';
    }
  }
}
